export default __webpack_public_path__ + "static/media/step-visited.a803ce1f.svg";